export const ManagerContentTotalsTranslations = {
  TOTALS: {
    es: 'Totales',
    en: 'Totals',
    cat: 'Totals',
    eus: 'Totals',
    pt: 'Total'
  },
  TEACHERS: {
    es: 'Profesores',
    en: 'Teachers',
    cat: 'Professors',
    eus: 'Irakasleak',
    pt: 'Professores'
  },
  TAG: {
    es: 'Formación',
    en: 'Category',
    cat: 'Formació',
    eus: 'Formakuntza',
    pt: 'Formação'
  },
  EMAIL: {
    es: 'Correo',
    en: 'Email',
    cat: 'Correu',
    eus: 'Email',
    pt: 'Email'
  },
  VIDEO_MINUTES: {
    es: 'Min. vídeo',
    en: 'Video min',
    cat: 'Min. vídeo',
    eus: 'Min. bideoa',
    pt: 'Min. vídeo'
  },
  PDF_PAGES: {
    es: 'Pág. apuntes',
    en: 'PDF pages',
    cat: 'Pág. apunts',
    eus: 'PDF orrialdeak',
    pt: 'Pág. apontes'
  },
  QUIZ_QUESTIONS: {
    es: 'Preguntas test',
    en: 'Quiz questions',
    cat: 'Preguntes test',
    eus: 'Test galderak',
    pt: 'Questões de teste'
  },
  DOWNLOAD_SELECTED: {
    es: 'Descargar seleccionados ({{count}})',
    en: 'Download selected ({{count}})',
    cat: 'Descarregar seleccionats ({{count}})',
    eus: 'Hautatutakoak deskargatu ({{count}})',
    pt: 'Descarregar selecionados ({{count}})'
  },
  EXPORT_ALL: {
    es: 'Exportar todo',
    en: 'Export all',
    cat: 'Exportar tot',
    eus: 'Denak esportatu',
    pt: 'Exportar todos'
  }
};
